import { Checkbox, Divider, Grid, Typography } from '@mui/material';
import React, { useContext, useState } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import styles from "../../../assets/styles/componentStyles/chatbot.module.scss";
import workflowStyle from './../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss';
import { getDeploymentTriggerPayload} from '../../../models/flowBuilderTypes'; 
import GlobalButton from '../../utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from '../../../services/api';
import { useSearchParams } from 'react-router-dom';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface DeletePostDeploymentTriggerWarningPopupProps {
    setFlagDeletePostDeploymentTriggerWarning: React.Dispatch<React.SetStateAction<boolean>>,
    listOfDeletedSteps: getDeploymentTriggerPayload[], 
    publishChatbot: (flagReset: boolean) => Promise<void>,
} 

const DeletePostDeploymentTriggerWarningPopup: React.FC<DeletePostDeploymentTriggerWarningPopupProps> = (props) => {
    
    const { setFlagDeletePostDeploymentTriggerWarning, listOfDeletedSteps, publishChatbot } = props;
    const [flagDeleteStep, setFlagDeleteStep] = useState<boolean>(false);
    const [flagReset, setFlagReset] = useState<boolean>(true);
    const { setFlagLoading } = useContext(UserContext) as UserContextPayload 

    const { showError } = useGenericStore(useShallow((state) => ({
        showError: state.showError
    })))

    const [searchParams] = useSearchParams();
    const chatbotId = searchParams.get('workflow_id');

    const onTheClickOfPublish = async () => { 
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true})); 
        try {
             const responses = await Promise.all((listOfDeletedSteps || []).map(step => { 
                    const payload = {
                        ...step, 
                        flag_deleted: true,
                    }
                    return agent.handleChatbotPostDeploymentTrigger.post(payload, chatbotId || "");
                })
            ); 

            const allSuccess = responses.every(res => res?.status);
            if(allSuccess){
                await publishChatbot(flagReset);
            } else {
                showError("Something went wrong!")
            }
        } catch (err) {
            console.error("Error occurs while deleting post deployment trigger condition: ", err);
        }
        setFlagDeletePostDeploymentTriggerWarning(false);
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}>Validation Error: Missing Step in Keyword-Based Routing</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} /> 

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Typography sx={{fontSize: "15px !important", fontWeight: "500 !important", whiteSpace: "pre-wrap !important"}}>
                                        Some of your Keyword-Based Routing condition are linked to steps that no longer exist.<br />
                                        {`The following steps were deleted but still being referenced in your Keyword-Based Routing condition: ${listOfDeletedSteps.map(step => step?.chatbot_step?.chatbot_step_name).filter(Boolean).join(", ")}`}<br /><br />

                                        To continue, Please do one of the following: <br />
                                        1. Update your conditions to point to valid steps<br />
                                        2. Delete the invalid condition mappings
                                    </Typography>
                                </Grid> 

                                <Grid item xs={12}>
                                    <Grid container alignItems={"center"} gap={"12px"}>
                                        <Grid item className={workflowStyle.checkBoxStyle}>
                                            <Checkbox 
                                                className={`${styles.checkedIcon}`} 
                                                disableRipple 
                                                checked={flagDeleteStep}
                                                onChange={(event) => { setFlagDeleteStep(event.target.checked); setFlagReset(true); }} 
                                            />
                                        </Grid>
                                        <Grid item className={styles.checkboxStyle}>Delete invalid mappings</Grid>
                                    </Grid>
                                </Grid> 

                                {flagDeleteStep && 
                                    <>
                                        <Grid item xs={12}>
                                            <Grid container alignItems={"center"} gap={"12px"}>
                                                <Grid item className={workflowStyle.checkBoxStyle}>
                                                    <Checkbox 
                                                        className={styles.checkedIcon} 
                                                        disableRipple 
                                                        checked={flagReset}
                                                        onChange={(event) => { setFlagReset(event.target.checked) }} 
                                                    />
                                                </Grid>
                                                <Grid item className={styles.checkboxStyle}>Reset all chatbot conversations</Grid>
                                            </Grid>
                                        </Grid>  

                                        <Grid item xs={12}>
                                            <Grid container sx={{marginTop: "10px", justifyContent: "end"}}>
                                                <Grid item>
                                                    <GlobalButton
                                                        buttonText="Go Live"
                                                        className='primaryButtonStyle'
                                                        sx={{width: "130px"}} 
                                                        onClick={() => onTheClickOfPublish()}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default DeletePostDeploymentTriggerWarningPopup
